import React, { useEffect, useMemo, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toAbsoluteUrl,
} from "../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { StatusColumnFormatter } from "../topup-table/column-formatters";
import { sizePerPageList } from "../TopUpUIHelpers";
import SVG from "react-inlinesvg";
import VisibilityIcon from "@material-ui/icons/Visibility";

const InvoiceListTable = ({
  invoiceData = [],
  queryParams,
  setQueryParams,
  listLoading,
  totalCount,
  history,
}) => {
  // Table columns
  const columns = [
    {
      dataField: "invoice_hid",
      text: "Invoice ID",
      classes: "text-center",
      headerClasses: "text-center",
    },
    {
      dataField: "status",
      text: "Status",
      classes: "text-center",
      headerClasses: "text-center",
      formatter: (cell) => {
        return StatusColumnFormatter(cell);
      },
    },
    {
      dataField: "invoice_price",
      text: "Harga",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
      classes: "text-right",
      headerClasses: "text-right",
    },
    {
      dataField: "invoice_tax",
      text: "Pajak",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
      classes: "text-right",
      headerClasses: "text-right",
    },
    {
      dataField: "invoice_grand_total",
      text: "Total Pembayaran",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
      classes: "text-right",
      headerClasses: "text-right",
    },
    {
      formatter: (cell, row) => {
        return (
          <OverlayTrigger
            overlay={
              <Tooltip id="products-edit-tooltip">Detail Invoice</Tooltip>
            }
          >
            <a
              className="btn btn-icon btn-light btn-hover-info btn-sm mx-3"
              onClick={() => {
                history.push(`/billing/top-up/${row.uuid}/invoice`);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-dark">
                {/* <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")}
                /> */}
                <VisibilityIcon />
              </span>
            </a>
          </OverlayTrigger>
        );
      },
      classes: "text-right",
      headerClasses: "text-right",
    },
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={invoiceData === null ? [] : invoiceData}
                columns={columns}
                onTableChange={getHandlerTableChange(setQueryParams)}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={invoiceData} />
                <NoRecordsFoundMessage entities={invoiceData} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default InvoiceListTable;
